import {
  UPDATE_PVS_SUBCATEGORY_REQUEST,
  UPDATE_PVS_SUBCATEGORY_SUCCESS,
  UPDATE_PVS_SUBCATEGORY_FAILURE,
  RESET_PVS_SUBCATEGORY_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const updatePvsSubcategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PVS_SUBCATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case UPDATE_PVS_SUBCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Subcategory updated successfully",
      };

    case UPDATE_PVS_SUBCATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to update subcategory",
      };

    case RESET_PVS_SUBCATEGORY_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default updatePvsSubcategoryReducer;
